module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_SKmagic_m2.a46c7f75106cc10c49ed7d2deda1db45.png";